import React from 'react';
import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate('/');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        textAlign: 'center', 
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4} justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={6}>
            <Typography
              variant="h1"
              sx={{
                fontSize: '14rem',
                fontWeight: 'bold',
              }}
            >
              404
            </Typography>
            <Typography
              variant="h5"
              sx={{
                marginBottom: 3, 
              }}
            >
              The page you’re looking for doesn’t exist.
            </Typography>
            <Button
              variant="contained"
              onClick={handleBackHome}
              sx={{
                padding: '25px 40px',
                fontSize: '1.6rem', 
              }}
            >
              Back Home
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
